import React from 'react';
import ServiceCategoriesListPage from '~/components/Services/ServiceCategoriesListPage';
import { ServiceCategoryPage } from '~/components/Services/ServiceCategoryPage';
import { requireNamespaces } from '~/locale/i18n';

export const servicesIndex = (context: any, params: any) => {
  return {
    chunks: ['services'],
    component: <ServiceCategoriesListPage />,
    accountWrapper: {
      loginRequired: false,
      nonBlocking: true,
    },
    ...requireNamespaces('common', 'account'),
  };
};

export const serviceTypePage = (context: any, params: any) => {
  return {
    chunks: ['services'],
    component: <ServiceCategoryPage categorySlug={params.categorySlug} />,
    accountWrapper: {
      loginRequired: false,
      nonBlocking: true,
    },
    ...requireNamespaces('common'),
  };
};

if (module.hot) {
  module.hot.accept();
}
